import { useCookieConsent } from '@packages/shared';
import { useEffect } from 'react';
import { useTracking } from '../../../hooks';
import { ExternalScriptTestIds } from '../types';

export const Zoovu = ({ advisorId, zoovuURL }: { advisorId?: string; zoovuURL?: string }) => {
  const isAllowed: boolean = useCookieConsent('C0002');
  const dispatchGTMEvent = useTracking();
  const event = advisorId ? 'renderZoovuScript' : 'renderZoovuScriptURL';

  useEffect(() => {
    // this definition is placed here - it has some dependencies on variables in this useEffect
    const eventValue = advisorId ? { zoovuAdvisorId: advisorId } : { zoovuURL };
    if (isAllowed) {
      dispatchGTMEvent({
        event,
        eventValue,
      });
    }
  }, [advisorId, dispatchGTMEvent, event, isAllowed, zoovuURL]);

  return (
    <div
      data-testid={ExternalScriptTestIds.ZoovuScript}
      id="zoovu-assistant"
      data-scroll-behavior="noscroll"
    />
  );
};
